module.exports = __webpack_public_path__ + "71f150a44fba0db23a9c620e3ae53db9.ttf";